import * as constants from './config/constants.js';
import ElementClassHandler from './utils/element-class-handler.js';
import MDLFormFields from './utils/mdl-form-fields.js';
import Selectors from './utils/selectors.js';

export default class ExistingNumber {
    constructor(options = {}) {
        this.dataIdentifier = options.dataIdentifier || 'data-existing-number-id';
        this.dataOptionsIdentifier = options.dataOptionsIdentifier || 'data-existing-number-options';
        this.selectors = new Selectors({
            dataAttrId: this.dataIdentifier
        });
        this.existingNumberIdentifier = options.existingNumberIdentifier || 'form_existingNetworkDetails_';
        this.fieldType = options.fieldType || 'radio';
        this.elementClassHandler = new ElementClassHandler;
        this.existingNumberFields = this.selectors.querySelectorArray(this.selectors.attrSelector(this.dataIdentifier));
        this.options = JSON.parse(document.querySelector(this.selectors.attrSelector(this.dataOptionsIdentifier)).value);
        this.mdlFormFields = new MDLFormFields;
    }

    setup() {
        if (this.existingNumberFields.length) {
            this.setDefaultView();
            this.setupFormListener();
        }
    }

    toggleRequired(existingNumberId, existing) {
        let existingNumberField = document.querySelector('#' + this.existingNumberIdentifier + existingNumberId),
            existingNumberFieldRow = document.querySelector('#' + this.existingNumberIdentifier + existingNumberId + '_row'),
            existingNumberFieldLabel = document.querySelector(this.selectors.attrSelector(this.dataIdentifier, existingNumberId) + ' .' + constants.MDL_TEXTFIELD_LABEL_CLASS);
        if (existing == 1) {
            existingNumberField.setAttribute('required', 'required');
            this.elementClassHandler.add(existingNumberFieldLabel, 'required');
            if (existingNumberField.value) {
                existingNumberField.parentNode.MaterialTextfield.checkValidity();
            } else {
                this.elementClassHandler.remove(existingNumberField.parentNode, 'is-valid');
            }
            this.elementClassHandler.show(existingNumberFieldRow);

        } else {
            existingNumberField.removeAttribute('data-required');
            existingNumberField.removeAttribute('required');
            existingNumberField.value = '';
            this.elementClassHandler.remove(existingNumberFieldLabel, 'required');
            this.elementClassHandler.remove(existingNumberFieldLabel.parentElement, 'is-invalid');
            this.elementClassHandler.hide(existingNumberFieldRow);
        }
    }

    setDefaultView() {
        let self = this;
        this.existingNumberFields.forEach(function(el) {
            let existingNumberId = self.getExistingNumberId(el);
            let status = self.options[existingNumberId];
            if (status !== 'order') {
                return;
            }
            let errorField = el.querySelector('[data-existing-number-error]');
            self.elementClassHandler.hide(errorField);
            let existingFieldChoice = el.querySelector('input:checked');
            if (!existingFieldChoice || existingFieldChoice.value == 0) {
                self.toggleRequired(existingNumberId, 0);
            }
            if (!existingFieldChoice) {
                document.querySelector('.form-submit').addEventListener('click', (e) => {
                    let existingFieldChoice = el.querySelector('input:checked');
                    if (existingFieldChoice) {
                        return true;
                    }
                    e.preventDefault();
                    self.elementClassHandler.show(errorField);
                    return false;
                });
            }
        });
    }

    setupFormListener() {
        let self = this;
        this.existingNumberFields.forEach(function(elem) {
            let existingNumberId = self.getExistingNumberId(elem);
            let status = self.options[existingNumberId];
            if (status === 'upgrade') {
                self.toggleRequired(existingNumberId, 1);
                return;
            }
            let existingFieldChoices = self.selectors.querySelectorArray('input' + self.selectors.attrSelector('type', self.fieldType), elem);
            existingFieldChoices.forEach(function(el) {
                el.addEventListener('change', (e) => {
                    let errorField = elem.querySelector('[data-existing-number-error]');
                    self.elementClassHandler.hide(errorField);
                    e.preventDefault();
                    self.toggleRequired(existingNumberId, el.value);
                });
            });
        });
    }

    getExistingNumberId(element) {
        return element.getAttribute(this.dataIdentifier);
    }
}
